import {getFormattedDate} from "../formatDate";
import {ShoppingPresentationValueObject} from "../../model/vo/content/ShoppingPresentationValueObject";
import {PlacePresentationValueObject} from "../../model/vo/content/place/PlacePresentationValueObject";

export const checkGuideVisible = (expirationDate: Date | null, updateExpirationDate: (arr: string[])=>void ) => {
    if (expirationDate && getFormattedDate(new Date(expirationDate)).getTime() != getFormattedDate(new Date()).getTime()) {
        updateExpirationDate([])
    }
}

export const setCurrentPage = (
    data: ShoppingPresentationValueObject | PlacePresentationValueObject,
    hiddenGuideList : string[],
    currentPage: string,
    nextPage: string,
    updateCurrentPage:(page: string) => void,
    updateNextPage:(page: string) => void,
    updateHiddenGuideList:(arr : string[]) => void,
    updatePrevPathType:(prevPathType : number) => void,
    prevPathType: number | null,
    curPathType: number
) => {

    // if(currentPage === 'Mission') return;
    //
    // const isIncluded = (data.value?.mappedImageUrls['0']==null && data.value != null) ? true : hiddenGuideList.includes(data.value?.mappedImageUrls["0"]?.fileUrl || '');
    //
    //
    // if((currentPage === 'none' && nextPage === 'none') || !isIncluded ) {
    //     updateCurrentPage('GuideLine');
    //     updateNextPage('Mission');
    // } else if(isIncluded) {
    //     updateCurrentPage('Mission');
    //     updateNextPage('Mission');
    // }

    if(data.mappedImageUrls['0']===null){
        updateCurrentPage('Mission');
        return
    }

    if(currentPage === 'Mission' && (prevPathType == null || curPathType == prevPathType)) return;

    updateCurrentPage('GuideLine');
    updateNextPage('Mission');
    updatePrevPathType(curPathType);
}